import { toast } from "react-toastify";
let autoCloseTime = 1500;

export const errorMessage = (text = "") => {
  toast.error(text, {
    autoClose: autoCloseTime,
  });
};

export const successMessage = (text = "") => {
  toast.success(text, {
    autoClose: autoCloseTime,
  });
};

export const warningMessage = (text = "") => {
  toast.warn(text, {
    autoClose: autoCloseTime,
  });
};

export const infoMessage = (text = "") => {
  toast.info(text, {
    autoClose: autoCloseTime,
  });
};
